// extracted by mini-css-extract-plugin
module.exports = {"image":"LinkBankSuccessPage_image__2Zkh2","innerText":"LinkBankSuccessPage_innerText__3eT53"};